import { createPortal } from "react-dom";
import Ticket from "../Ticket";
import styles from "./styled.module.css";

export function TicketModal({ ticketId, onClose }) {
    return createPortal(
        <div className={styles.modalOverlay} onClick={onClose}>
            <div
                className={styles.modalContent}
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    className={styles.modalClose}
                    onClick={onClose}
                    type="button"
                >
                    ✕
                </button>

                <div className={styles.modalBody}>
                    <Ticket ticketId={ticketId} onClose={onClose} />
                </div>
            </div>
        </div>,
        document.body
    );
}